export default {
  hasAvatar: ({ basicInfo }) => {
    return basicInfo.photo_url !== undefined && basicInfo.photo_url !== "";
  },
  avatar: ({ basicInfo }) => {
    return basicInfo.photo_url;
  },
  hasResume: ({ basicInfo }) => basicInfo.curriculum_url.length > 0 || false,
  getBasicInfo: (state) => state.basicInfo,
  emptyBasic: ({ basicInfo }) =>
    Object.keys(basicInfo).filter(
      (key) =>
        (key !== "curriculum_url" &&
          key !== "photo_url" &&
          basicInfo[key] != "") ||
        basicInfo[key] != null
    ).length < 7,
  emptyCurriculumn: ({ basicInfo }) =>
    (!basicInfo.hasOwnProperty("curriculum_url") &&
      basicInfo.curriculum_url == "") ||
    basicInfo.curriculum_url == null,
};
